import clsx from 'clsx'
import React, { FC } from 'react'

import SvgAngleLeft from '@Assets/SVG/AngleLeft'
import SvgAngleRight from '@Assets/SVG/AngleRight'
import { SliderData } from '@Components/Slider'

import styles from './SliderArrows.module.scss'

export interface SliderArrowLeftProps {
  className?: string
  onClick?: () => void
  sliderState: SliderData | null
}

export const SliderArrowLeft: FC<SliderArrowLeftProps> = ({ className, onClick, sliderState }) => (
  <button
    aria-label="Previous"
    className={clsx(styles.sliderArrow, className, 'arrowPrevious', styles.left, (!sliderState || !sliderState.isScrollable) && styles.hidden)}
    onClick={onClick}
    type="button"
  >
    <SvgAngleLeft />
  </button>
)
export const SliderArrowRight: FC<SliderArrowLeftProps> = ({ className, onClick, sliderState }) => (
  <button
    aria-label="Next"
    className={clsx(styles.sliderArrow, className, 'arrowNext', styles.right, (!sliderState || !sliderState.isScrollable) && styles.hidden)}
    onClick={onClick}
    type="button"
  >
    <SvgAngleRight />
  </button>
)

